import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { AutoComplete } from 'primereact/autocomplete';
import { Divider } from 'primereact/divider';
import http from "../../../src/Redux/services/http-common.jsx";
import moment from 'moment';

function BookingConsultation({ selectedPatient, onClose ,handleSearchSubmit,setStatus}) {
    const [date, setDate] = useState(null);
    const [time, setTime] = useState(null);
    const [consultationType, setConsultationType] = useState('');
    const [reason, setReason] = useState('');
    const [doctors, setDoctors] = useState([]);
    const [filteredDoctors, setFilteredDoctors] = useState([]);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [availableTimes, setAvailableTimes] = useState([]);
      const [locationId, setLocationId] = useState(null);
      const [hospitslId, sethospitalId] = useState();
      const [quickConsulted,setQuickconsulted] =useState();
      // under your other useState calls
const [userHospitalLocation, setUserHospitalLocation] = useState(null);

    const toast = useRef(null);

    // Format date to MM/DD/YYYY for API
    console.log(selectedPatient,"rtgyh")

    const formatDateForAPI = (dateObj) => {
        if (!dateObj) return null;
        return moment(dateObj).format("MM/DD/YYYY");
    };


    // Fetch doctors list
    useEffect(() => {
        const fetchDoctors = async () => {
            try {
                const url = `${process.env.REACT_APP_ELASTIC_BASEURL}doctors?pageNo=1&pageSize=100`;
                const response = await http.get(url);

                const doctorOptions = response.data.map(doctor => ({
                    name: doctor.userName,
                    specialization: doctor.specialization || 'General Practitioner',
                    id: doctor.userId,
                    code: doctor.userId, 
                    email: doctor.email,
                    contactNo: doctor.contactNo,
                    seoId:doctor.seoNameId
                }));

                setDoctors(doctorOptions);
                setFilteredDoctors(doctorOptions); 
            } catch (error) {
                console.error("Error fetching doctors:", error);
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load doctors list',
                    life: 3000
                });
            }
        };

        fetchDoctors();
    }, []);

    // Fetch available times when doctor or date changes
const fetchAvailableTimes = useCallback(async (doctorId, selectedDate) => {
    if (!doctorId || !selectedDate) {
        setAvailableTimes([]);
        return;
    }

    try {
        const formattedDate = formatDateForAPI(selectedDate);
        const response = await http.post(
            `${process.env.REACT_APP_BASEURL}medicare/getDoctorAvailability`,
            {
                userId: doctorId,
                fromDate: formattedDate
            }
        );

        const data = response.data || {};
        const validTimes = Object.keys(data).filter(time => data[time] === "Y");

        setAvailableTimes(validTimes); // ✅ Just array of time strings like ["00:05", "00:10", ...]
        setTime(null); // Optional: reset time dropdown on each fetch
    } catch (error) {
        console.error("Error fetching available times:", error);
        toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to load available time slots',
            life: 3000
        });
    }
}, []);


    useEffect(() => {
        if (selectedDoctor?.code && date) {
            fetchAvailableTimes(selectedDoctor.code, date);
             fetchLocationId(selectedDoctor.seoId);
        } else {
            setAvailableTimes([]);
        }
    }, [selectedDoctor, date, fetchAvailableTimes]);

    console.log(selectedDoctor,"e4rtyhuji")
    
    

    const searchDoctors = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length) {
                setFilteredDoctors([...doctors]);
            } else {
                setFilteredDoctors(
                    doctors.filter(doctor =>
                        doctor.name.toLowerCase().includes(event.query.toLowerCase())
                    )
                );
            }
        }, 250);
    };

const doctorTemplate = (doctor) => (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px 10px',
        borderBottom: '1px solid #f0f0f0'
    }}>
        <div style={{
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            backgroundColor: '#e0f2ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px'
        }}>
            <i className="pi pi-user" style={{ color: '#2563eb', fontSize: '16px' }}></i>
        </div>
        <div>
            <div style={{ fontWeight: '600', fontSize: '14px', color: '#111827' }}>
                {doctor?.name}
            </div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>
                {doctor?.specialization }
            </div>
        </div>
    </div>
);


 const fetchLocationId = async (doctorId) => {
   try {
     const { data } = await http.get(
       `${process.env.REACT_APP_BASEURL}User_Hospital_Location/list?userId=${doctorId}&status=1&source=b2c`
     );
     if (data?.length) {
       setUserHospitalLocation(data[0]);
     }
   } catch (error) {
     console.error("Error fetching user_hospital:", error);
   }
 };

      
        const updatedToTimeDoc = moment(time, "HH:mm")
          .add(15, "minutes")
          .format("HH:mm");
        console.log(updatedToTimeDoc, "time")
console.log(selectedDoctor,selectedDoctor?.inPersonConsultCharges,"drftgyhuj")


 const handleSubmit = async () => {
  if (!selectedPatient || !date || !time || !selectedDoctor || !consultationType) {
    toast.current.show({
      severity: 'error',
      summary: 'Error',
      detail: 'Please fill all required fields',
      life: 3000
    });
    return;
  }

  const fromTime = time;
  const toTime = moment(fromTime, "HH:mm").add(5, "minutes").format("HH:mm");

const payload = {
  consultationsReason: reason || "",
  consultationsType: consultationType,
  createdBy: selectedPatient.createdby || "",
  fromTime,  
  toTime,    

  // pulled from your new state
  hospitalId:  userHospitalLocation?.hospitalId  || "ECLINIC",
  locationId:  userHospitalLocation?.locationId  || "LOC_ECLINIC",

  // patient’s eClinic details
  cheCenterId:   selectedPatient?.eclinicDetails?.hospitalCode,
  cheBranchId:   selectedPatient?.eclinicDetails?.code,
  cheCenterName: selectedPatient?.eclinicDetails?.description,
  cheBranchName: selectedPatient?.eclinicDetails?.name,

  modifiedBy: selectedPatient.createdby || "",
  patientEmail:    selectedPatient.patient?.email || "",
  patientId:       selectedPatient?.patientid,
  patientMobileNo: selectedPatient.patient?.mobile,
  patientName:     `${selectedPatient.patient?.firstName || ""} ${selectedPatient.patient?.lastName || ""}`.trim(),

  status: 1,
  whenAppointment: formatDateForAPI(date),  

  // doctor info
  userEmail:          userHospitalLocation.userEmail,
  userId:             userHospitalLocation.userId,
  userMobile:         userHospitalLocation.userMobileNo,
  userName:           userHospitalLocation.userName,
  userQualification:  userHospitalLocation.qualification || "MBBS",
  userSalutation:     userHospitalLocation.userSalutation   || "Dr.",

  // quick vs specialist
  quickConsulted: userHospitalLocation?.userQuickConsulted || 0,
  masterServiceType:
    userHospitalLocation?.userQuickConsulted == 1
      ? "Quick Consultation"
      : "Specialist Consultation",

  // financials
  totalAmount:
    consultationType === "I"
      ? Number(userHospitalLocation?.inPersonConsFee)
      : Number(userHospitalLocation?.videoConsFee    ?? selectedDoctor.videoConsultCharges),

  curebayFee:
    consultationType === "I"
      ? Number(userHospitalLocation?.inPersonConsFee  ?? userHospitalLocation.inPersonConsultCharges)
      : Number(userHospitalLocation?.videoConsFee),     

  discountPercentage: 0,

  // payment & routing
  txnId:                   "",
  payMode:                 "Cash",
  productinfo:             "Appointment",
  paymentLinkForPatient:   "N",
  appointmentVideoUrl:     "https://doctor-stage.curebay.in/sharecall/",

  userRoleCode:   "CHE",
  sourceChannel:  "ECLINIC"
};


  console.log(payload,"drfgth")

  try {
    const response = await http.post(`${process.env.REACT_APP_CHE_BASEURL}PatientAppointment/saveApp`, payload);
    console.log(response?.data,"gyhjnm")
     const txnId = response?.data?.data;
    toast.current.show({
      severity: 'success',
      summary: 'Success',
      detail: 'Consultation booked successfully!',
      life: 3000
    });
        if (txnId) {

            const updateOrdersUrl = 
      `${process.env.REACT_APP_COMMON_BASEURL}PatientCart/updateOrders` +
      `?status=1&txnId=${txnId}&type=A`;
    const updateCartRes = await http.put(updateOrdersUrl);
    const newOrderId = updateCartRes?.data?.data;
    if (!newOrderId) throw new Error("Cart update failed");

     const labOrderId = selectedPatient.orderid;
      const updateUrl = `${process.env.REACT_APP_DIAGNOSTIC}patientLabTestsOrder/update-orderMapping?acticeLabOrderId=${labOrderId}&type=A&orderId=${newOrderId}`;

      await http.put(updateUrl);

      toast.current.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Consultation booked and order updated!',
        life: 3000
      });

      onClose();
      handleSearchSubmit();
      setStatus(24);
    } else {
      throw new Error("Appointment ID missing in response");
    }
  
  } catch (error) {
    console.error("Booking error:", error);
    toast.current.show({
      severity: 'error',
      summary: 'Error',
      detail: 'Failed to book appointment',
      life: 3000
    });
  }
};


    return (
      <div style={{ minWidth: '600px', padding: '24px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
    <Toast ref={toast} />

    {selectedPatient && (
        <div style={{ marginBottom: '24px', padding: '20px', backgroundColor: '#f0f8ff', borderRadius: '6px', border: '1px solid #dbeafe' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#1e3a8a', marginBottom: '16px' }}>Patient Information</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div>
                    <label style={{ fontSize: '14px', color: '#4b5563', marginBottom: '4px', display: 'block' }}>Patient Name</label>
                    <InputText
                        value={`${selectedPatient.patient?.firstName || ''} ${selectedPatient.patient?.lastName || ''}`}
                        style={{ width: '100%', backgroundColor: '#fff' }}
                        readOnly
                    />
                </div>
                <div>
                    <label style={{ fontSize: '14px', color: '#4b5563', marginBottom: '4px', display: 'block' }}>Mobile Number</label>
                    <InputText
                        value={selectedPatient.patient?.mobile || ''}
                        style={{ width: '100%', backgroundColor: '#fff' }}
                        readOnly
                    />
                </div>
                <div>
                    <label style={{ fontSize: '14px', color: '#4b5563', marginBottom: '4px', display: 'block' }}>Order ID</label>
                    <InputText
                        value={selectedPatient.orderid || ''}
                        style={{ width: '100%', backgroundColor: '#fff' }}
                        readOnly
                    />
                </div>
            </div>
        </div>
    )}

    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div>
            <label style={{ fontSize: '14px', color: '#4b5563', marginBottom: '4px', display: 'block' }}>Select Doctor*</label>
            <AutoComplete
                value={selectedDoctor}
                suggestions={filteredDoctors}
                completeMethod={searchDoctors}
                field="name"
                dropdown
                onChange={(e) => setSelectedDoctor(e.value)}
                itemTemplate={doctorTemplate}
                placeholder="Search doctors..."
                className="w-full"
                inputStyle={{ width: '100%' }}
                style={{ width: '100%' }}
                dropdownMode="current"
            />
            {selectedDoctor && (
                <div style={{ marginTop: '8px', fontSize: '12px', color: '#6b7280' }}>
                    Selected: {selectedDoctor.name} ({selectedDoctor.specialization})
                </div>
            )}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div>
                <label style={{ fontSize: '14px', color: '#4b5563', marginBottom: '4px', display: 'block' }}>Appointment Date*</label>
                <Calendar
                    value={date}
                    onChange={(e) => setDate(e.value)}
                    style={{ width: '100%' }}
                    minDate={new Date()}
                    showIcon
                    dateFormat="mm/dd/yy"
                    placeholder="Select date"
                />
            </div>
            <div>
                <label style={{ fontSize: '14px', color: '#4b5563', marginBottom: '4px', display: 'block' }}>Time Slot*</label>
                <Dropdown
                    value={Array.isArray(availableTimes) && availableTimes.includes(time) ? time : null}
                    options={Array.isArray(availableTimes) ? availableTimes.map(t => ({ label: t, value: t })) : []}
                    onChange={(e) => setTime(e.value)}
                    placeholder={availableTimes?.length ? "Select time" : "No available times"}
                    style={{ width: '100%' }}
                    disabled={!Array.isArray(availableTimes) || !availableTimes.length}
                />
            </div>
        </div>

        <div>
            <label style={{ fontSize: '14px', color: '#4b5563', marginBottom: '4px', display: 'block' }}>Consultation Type*</label>
            <Dropdown
                value={consultationType}
                options={[
                    { label: "Video", value: "V" },
                    { label: "In-Person", value: "I" },
                ]}
                onChange={(e) => setConsultationType(e.value)}
                placeholder="Select type"
                style={{ width: '100%' }}
            />
        </div>

        <div>
            <label style={{ fontSize: '14px', color: '#4b5563', marginBottom: '4px', display: 'block' }}>Reason for Consultation</label>
            <InputText
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Briefly describe the reason"
                style={{ width: '100%' }}
            />
        </div>
    </div>

    <hr style={{ margin: '30px 0', borderColor: '#e5e7eb' }} />

    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
        <Button
            label="Cancel"
            className="p-button-outlined p-button-secondary"
            onClick={onClose}
        />
        <Button
            label="Confirm Booking"
            icon="pi pi-check"
            onClick={handleSubmit}
            style={{
                backgroundColor: '#2563eb',
                borderColor: '#2563eb',
                color: '#fff'
            }}
        />
    </div>
</div>

    );
}

export default BookingConsultation;